/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Refresh_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Folders refreshed" |
*
* @param {Explorer_Nav_Refresh_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_refresh_success_toast = /** @type {((inputs?: Explorer_Nav_Refresh_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Refresh_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossiers actualises")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartelle aggiornate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Папки обновлены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpetas actualizadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹已刷新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダが更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर रीफ़्रेश हो गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pastas atualizadas")
	return /** @type {LocalizedString} */ ("Folders refreshed")
});